module.exports = __webpack_public_path__ + "static/img/解决方案moli.60a5690.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/解决方案moli.png
// module id = 2wTD
// module chunks = 1